module.exports = __webpack_public_path__ + "static/wtw-green-logo-4230784d9a81774bdc0d125668f3f260.svg";